import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { AddToWishlishtTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToWishlist.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";
import { TrackingProductModel } from "@/services/tracking/types/trackingProduct.model";

export const track = (trackingInfo: AddToWishlishtTrackingInfo) => {
    const event: TypedAnalyticsEvent<AddToWishlishtTrackingInfo> = {
        event: EventType.AddToWishlist,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackProduct = (product: TrackingProductModel) => {
    track(product);
};
